import React, { useState } from 'react'
import { NumberInputWrapper, Title, Input, InputBox } from './NumberInputStyles'
import { NumberInputProps } from './Interface'
import { FlexDiv } from '../../elements/NumberInput/NumberInputStyles'
import { ReactComponent as Infinte } from '../../../lib/assets/infinite.svg'

export default function NumberInput({
  title,
  placeholder,
  width,
  height,
  fontSize,
  value,
  handleChange,
  handleBlur,
  children,
  padding,
  h,
  readOnly,
  color,
  maxWidth,
  y,
  isError,
  margin,
  inputMode,
  switchText,
  checked,
  rolls,
  maxLength,
  autoPlayIsOn,
  name,
}: NumberInputProps) {
  const [focus, setFocus] = useState<boolean>(false)
  const Blur = (e: any) => {
    if (!readOnly) {
      handleBlur(e)
      e.target.placeholder = placeholder
      setFocus(false)
    }
  }
  const Focus = (e: any) => {
    if (!readOnly) {
      e.target.placeholder = ''
      setFocus(true)
    }
  }

  const Change = (e: any) => {
    handleChange(e)
  }
  return (
    <NumberInputWrapper
      width={width}
      height={height}
      focus={focus}
      padding={padding}
      isError={isError}
      margin={margin}
      autoPlayIsOn={autoPlayIsOn}
    >
      <FlexDiv startNow={true}>
        <Title>{title}</Title>
        <Title color={checked ? 'blue' : 'red'}>{switchText}</Title>
      </FlexDiv>
      <InputBox>
        {children}
        <Input
          type={'text'}
          pattern='\d*'
          inputMode={inputMode}
          min='0'
          placeholder={placeholder}
          fontSize={fontSize}
          focus={focus}
          color={color}
          maxWidth={maxWidth}
          h={h}
          y={y}
          maxLength={maxLength}
          value={
            name === 'ROLL_NUMBER' && value === '0'
              ? ''
              : value !== ''
              ? value
              : ''
          }
          onFocus={(e: any) => Focus(e)}
          onBlur={(e: any) => Blur(e)}
          onChange={(e: any) => Change(e)}
          onKeyDown={(e: any) => e.key === 'Enter' && handleBlur(e)}
          readOnly={readOnly}
        />
      </InputBox>
      {rolls && (value === '0' || value === '') && <Infinte />}
    </NumberInputWrapper>
  )
}
